import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { getLocalidades, deleteLocalidad } from "../helpers/rutaLocalidades";
import ModalLocalidad from "./ModalLocalidad";
import "../css/tableclientes.css";

const TableLocalidades = () => {
  const [localidades, setLocalidades] = useState({
    data: { localidades: [] },
    loading: true,
  });

  const [localidadSeleccionada, setLocalidadSeleccionada] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaLocalidades();
  }, []);

  const consultaLocalidades = () => {
    getLocalidades().then((datos) => {
      setLocalidades({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaLocalidades();
  };

  const handleShow = () => setShow(true);

  const modificaLocalidad = (localidad) => {
    setLocalidadSeleccionada({ localidades: localidad });
    handleShow();
  };

  const eliminarLocalidad = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la localidad?");
    if (confirmar) {
      deleteLocalidad(id).then(() => consultaLocalidades());
    }
  };

  return (
    <div className="table-container">
      {!localidades.loading && (
        <>
          <div className="col-12 mt-4"></div>
          <Table striped bordered hover>
            <thead>
              <tr className="header">
                <th className="borrar">Acciones</th>
                <th>Localidad</th>
                <th>Código Postal</th>
                <th>Provincia</th>
              </tr>
            </thead>
            <tbody>
              {localidades.data.localidades?.map((localidad) =>
                localidad.activo ? (
                  <tr key={localidad._id}>
                    <td className="borrar">
                      <button
                        className="btn btn-primary"
                        onClick={() => modificaLocalidad(localidad)}
                      >
                        <i className="fa fa-pencil-square-o" />
                      </button>
                      <button
                        className="btn btn-danger ml-2"
                        onClick={() => eliminarLocalidad(localidad._id)}
                      >
                        <i className="fa fa-trash-o" />
                      </button>
                    </td>
                    <td>{localidad.localidad}</td>
                    <td>{localidad.codigopostal}</td>
                    <td>{localidad.provincia.provincia}</td>

                  </tr>
                ) : null
              )}
            </tbody>
          </Table>
          <ModalLocalidad
            show={show}
            handleClose={handleClose}
            localidad={localidadSeleccionada}
          />
        </>
      )}
    </div>
  );
};

export default TableLocalidades;
